import { pushFinishAllApi } from "../api";
import Button from "../components/Button";
import Share from "../components/Share";
import { useData } from "../contexts/DataContext";
import styles from "./Congratulation.module.css";
import React, { useEffect, useRef } from "react";

function Congratulation(props) {

  function FinishGame() {
    props.navigateNextPage();
    props.setFinishGame(true);
  }

  return (
    <div className={styles.passpracetice}>
      <div className={styles.greenbox}>
        ยินดีด้วย
        <br />
        คุณได้ทำเกมทดสอบครบ
        <br />
        ทุกระดับแล้ว
      </div>
      <div className={styles.orangebox}>
        ไม่ว่าคุณจะผ่านหรือไม่ผ่านในแต่ละระดับ หรือทำได้ในระยะเวลาเท่าไหร่
        <br />
        <span className={styles.orangetext}>
          ขอให้ฝึกฝนต่อไป เพราะทักษะ ทางสมอง สามารถพัฒนาให้ดีขึ้นได้
        </span>
      </div>
      <Button onClick={FinishGame}>ดูผลการทดสอบ</Button>
    </div>
  );
}

export default Congratulation;
